import Quest from "./Quest";

export default class QuestKill extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._enemy = null;
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._enemy = metadata.enemy;
    }

    /**
     * @returns {string}
     */
    get enemy() {
        return this._enemy;
    }
}